module.exports = __webpack_public_path__ + "images/marketing/features/mobile-website-contacts.png";